import { format, getYear } from "date-fns";

import _ from "lodash";

const currentDate = (): Date => new Date();

export const getCurrentMonth = (): number =>
  _.toNumber(format(currentDate(), "M"));

export const getCurrentYear = (): number => getYear(currentDate());

export const getYearsFromNow = (numberOfYears: number): number =>
  getCurrentYear() + numberOfYears;
